export type ScreenId =
  | "loading"
  | "menu"
  | "pause"
  | "gameover"
  | "leaderboard"
  | "name"
  | "how"
  | "none";

const SCREEN_MAP: Record<Exclude<ScreenId, "none">, string> = {
  loading: "screen-loading",
  menu: "screen-menu",
  pause: "screen-pause",
  gameover: "screen-gameover",
  leaderboard: "screen-leaderboard",
  name: "screen-name",
  how: "screen-how",
};

export class Screens {
  private current: ScreenId = "loading";
  private returnTo: ScreenId = "menu";

  show(id: ScreenId): void {
    this.current = id;
    for (const [key, elId] of Object.entries(SCREEN_MAP)) {
      const el = document.getElementById(elId);
      if (!el) continue;
      const hide = key !== id;
      el.classList.toggle("hidden", hide);
      el.setAttribute("aria-hidden", hide ? "true" : "false");
    }
  }

  getCurrent(): ScreenId {
    return this.current;
  }

  openOverlay(id: Exclude<ScreenId, "none" | "loading">, from?: ScreenId): void {
    this.returnTo = from ?? (this.current === "none" ? "menu" : this.current);
    this.show(id);
  }

  closeOverlay(): void {
    this.show(this.returnTo === "none" ? "menu" : this.returnTo);
  }

  setHudVisible(visible: boolean): void {
    document.getElementById("hud")?.classList.toggle("hidden", !visible);
  }

  setHud(score: number, best: number): void {
    const s = document.getElementById("hud-score");
    const b = document.getElementById("hud-best");
    if (s) s.textContent = String(score);
    if (b) b.textContent = `Best ${best}`;
  }

  setLoadProgress(ratio: number): void {
    const bar = document.getElementById("load-bar");
    if (bar) bar.style.width = `${Math.round(ratio * 100)}%`;
  }

  setMenuPlayer(name: string): void {
    const el = document.getElementById("menu-player");
    if (el) el.textContent = `Player: ${name || "Guest"}`;
  }

  setGameOver(score: number, rankText: string, deathMsg?: string): void {
    const s = document.getElementById("go-score");
    const r = document.getElementById("go-rank");
    const title = document.getElementById("go-title");
    if (s) s.textContent = `Score: ${score}`;
    if (r) r.textContent = rankText;
    if (title && deathMsg) title.textContent = deathMsg;
  }

  showToast(msg: string, duration = 2000): void {
    let toast = document.getElementById("game-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "game-toast";
      toast.style.cssText = `
        position: fixed; top: 80px; left: 50%; transform: translateX(-50%);
        background: rgba(0,0,0,0.85); color: #fff; padding: 8px 18px;
        border-radius: 8px; font-family: 'Bangers', cursive; font-size: 20px;
        z-index: 9000; pointer-events: none; opacity: 0; transition: opacity 0.3s;
        text-align: center; white-space: nowrap;
      `;
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.opacity = "1";
    clearTimeout((toast as any)._tid);
    (toast as any)._tid = setTimeout(() => {
      toast!.style.opacity = "0";
    }, duration);
  }
}
